import React from 'react'
import PropTypes from 'prop-types'
import {Redirect, Route} from 'react-router-dom'

export default class AuthenticatedRoute extends Route{
	static propTypes = {
		isLoggedIn: PropTypes.bool.isRequired,
		...Route.propTypes
	}

	render(){
		const {route} = this.context.router
		const location = this.props.location || route.location
		if(this.state.match){
			return this.props.isLoggedIn ? super.render() : <Redirect to={{
				pathname: '/login',
				state: {referrer: location}
			}}/>
		}else{
			return null
		}
	}
}




// WEBPACK FOOTER //
// ./client/components/routes/AuthenticatedRoute.js